/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:a26fca7b-8efc-4e4e-a2b9-6b02fa960904",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_8ovbYElvQ",
    "aws_user_pools_web_client_id": "5ia8qsml6gfeccmv4upg0am0ke",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://sp4yn37x6rczthwgvks4i2r7yy.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_appsync_apiKey": "da2-fnertwau5zd75aydmgbqhpxeby",
    "aws_cloud_logic_custom": [
        {
            "name": "appCommandApi",
            "endpoint": "https://m91q5b1mlc.execute-api.us-east-2.amazonaws.com/labs",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
